var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ReportsApi } from '../../../api/reports-api';
import { ReportHelper } from '../../report-helper';
export class SDBridgeReportComponent {
    constructor(reportsApi, reportHelper, route, titleService) {
        this.reportsApi = reportsApi;
        this.reportHelper = reportHelper;
        this.route = route;
        this.isGenerating = false;
        this.error = false;
        this.errorMessage = this.reportHelper.reportErrorMessages.noReportData;
        this.todaysDate = new Date().toDateString();
        this.headers = [
            'Proj. ID',
            'Proj. Title',
            'Improv. Type',
            'Route',
            'County',
            'TYP App',
            'TIP App',
            'Let Date',
            'Let IND',
            'Bridge Work',
            'Bridge ID',
            'Bridge RefNo.',
            'Location',
            'Status Cde',
            'Deficient/Obselete',
            'Sufficiency Rating',
            'Bridge Bill',
            'Year Built',
            'Length',
            'Deck Width',
            'Deck Area',
            'HBRR Elig.',
            'Bus Plan Network',
            'Long.',
            'Lat.',
            'Post Limit Weight',
            'Post Limit Comb.'
        ];
        titleService.setTitle(titleService.getTitle() + ' : Poor Bridge Condition Report');
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.isGenerating = true;
            this.route.paramMap.subscribe(x => {
                this.bridgeKeys = JSON.parse(window.localStorage.getItem(x.get('id'))).bridgeKeys;
                this.loadReport();
            });
        });
    }
    loadReport() {
        this.isGenerating = true;
        return this.reportsApi.getSDBridgeReportData(this.bridgeKeys).then((reportData) => {
            this.reportData = reportData;
            this.isGenerating = false;
        }, (error) => {
            this.isGenerating = false;
            this.error = true;
        });
    }
    exportToCsv() {
        const filename = 'SDBridgeSummaryReport.csv';
        let finalValue = '';
        for (let headerIndex = 0; headerIndex < this.headers.length; headerIndex++) {
            const header = this.headers[headerIndex].replace(/,/g, '');
            if (headerIndex + 1 === this.headers.length) {
                finalValue += header + ',\n';
            }
            else {
                finalValue += header + ',';
            }
        }
        if (this.reportData.sdBridgeReports.length > 0) {
            const sdBridgeReports = this.reportData.sdBridgeReports;
            for (const report of sdBridgeReports) {
                finalValue += `${report.projectId},\
                    ${report.projectTitle},\
                    ${report.improvementShortDesc},\
                    ${report.stRtNo},\
                    ${report.ctyCode},\
                    ${report.typApp},\
                    ${report.tipApp},\
                    ${report.letDate},\
                    ${report.letInd},\
                    ${report.bridgeWork},\
                    I${report.bridgeId},\
                    ${report.brKey},\
                    ${report.location},\
                    ${report.postStatus},\
                    ${report.nbiRating},\
                    ${report.suffRating},\
                    ${report.bridgeBill},\
                    ${report.yearBuilt},\
                    ${report.length},\
                    ${report.deckWidth},\
                    ${report.deckArea},\
                    ${report.hbrrElig},\
                    ${report.busPlanNetwork},\
                    ${report.decLong},\
                    ${report.declat},\
                    ${report.postLimitWeight},\
                    ${report.postLimitComb}\n`;
            }
        }
        const blob = new Blob([finalValue], { type: 'text/csv;charset-utf-8;' });
        if (navigator.msSaveBlob) { // IE 10+
            navigator.msSaveBlob(blob, filename);
        }
        else {
            const link = document.createElement('a');
            const myLink = link;
            if (myLink.download !== undefined) { // feature detection
                // Browsers that support HTML5 download attribute
                const url = URL.createObjectURL(blob);
                myLink.setAttribute('href', url);
                myLink.setAttribute('download', filename);
                myLink.style.visibility = 'hidden';
                document.body.appendChild(myLink);
                myLink.click();
                document.body.removeChild(myLink);
            }
        }
    }
}
